import { Protocol } from '../Protocol';

export class LegalStandardV2Protocol {
  public static readonly SEARCH_LEGAL_STANDARD_V2_SPECIFICATION_DETAILS: string = `${Protocol.YATUNG_API_ROOT}/standardV2/legal/specification/detail/search`;
}
